/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    X,
} from '../../Constants/assets';

const InnerContainer = styled.div`
    position: absolute;
    z-index: 1000;
    width: 420px;
    height: fit-content;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    transform: translate(0%, 4%);
    right: 0;
`;
const CenterAllContainer = styled.div`
    width: 80%;
    height: fit-content;
    margin: 35px auto;
`;
const HeaderContainer = styled.div`
    width: 99%;
    height: 20%;
`;
const Header = styled.h1`
    font-weight: bold;
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40%;
`;
const BodyContainer = styled.div`
    height: 75%;
    width: 100%;
    overflow-y: auto;
`;

// TODO: Fix this, this is temporary fix
export default function ToolTipPopUp({ toggleToolTip, showToolTip }) {
    const { t } = useTranslation();
    if (!showToolTip) return null;
    return (
        <InnerContainer>
            <CenterAllContainer>
                {' '}
                <HeaderContainer>
                    <Header>
                        {t(`global_variables.resources.resources`)}
                        {/* <X
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                toggleToolTip(false);
                            }}
                        /> */}
                    </Header>
                </HeaderContainer>
                <BodyContainer>
                    <table
                        style={{
                            width: '100%',
                        }}
                    >
                        {/* head */}
                        <tr
                            style={{
                                width: '100%',
                                borderBottom: '2px solid gray',
                            }}
                        >
                            <td
                                style={{
                                    width: '33.33%',
                                    height: '100%',
                                    textAlign: 'center',
                                }}
                            />
                            <td style={{ fontWeight: 'bold' }}>{t(`sidebar.resources.tooltip.standard_cost`)} </td>
                            <td style={{ fontWeight: 'bold' }}>{t(`sidebar.resources.tooltip.cost_in_turn`)} </td>
                        </tr>
                        {/* Standard */}
                        <tr
                            style={{
                                width: '100%',
                                borderBottom: '2px solid gray',
                            }}
                        >
                            <td
                                style={{
                                    height: '100%',
                                    padding: '10px 0',
                                }}
                            >
                                <WhiteSource style={{ margin: '0 10px 4px 0' }} />
                                {t(`global_variables.resources.standard`)}
                            </td>
                            <td> $100 </td>
                            <td> $200 </td>
                        </tr>
                        {/* Senior */}
                        <tr
                            style={{
                                width: '100%',
                                borderBottom: '2px solid gray',
                            }}
                        >
                            <td
                                style={{
                                    height: '100%',
                                    padding: '10px 0',
                                }}
                            >
                                <RedSource style={{ margin: '0 10px 4px 0' }} />
                                {t(`global_variables.resources.senior`)}
                            </td>
                            <td> $200 </td>
                            <td> $400 </td>
                        </tr>
                        {/* Executive */}
                        <tr
                            style={{
                                width: '100%',
                                borderBottom: '2px solid gray',
                            }}
                        >
                            <td
                                style={{
                                    height: '100%',
                                    padding: '10px 0',
                                }}
                            >
                                <GreenSource style={{ margin: '0 10px 4px 0' }} />
                                {t(`global_variables.resources.executive`)}
                            </td>
                            <td> $500 </td>
                            <td> $1,000 </td>
                        </tr>
                    </table>
                </BodyContainer>
            </CenterAllContainer>
        </InnerContainer>
    );
}
